import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, forkJoin, throwError,of  } from 'rxjs';

import { environment } from '../../../environments/environment';
import { MaintenancePlan } from '../model/maintenance-plan.model';

@Injectable({
  providedIn: 'root'
})


export class PlanMantenimientoService {

  private http = inject(HttpClient);

  private apiUrl = `${environment.apiUrl}/api/planes-mantenimiento`;
  private actividadesApiUrl = `${environment.apiUrl}/api/planes-mantenimiento-actividades`;

  constructor() { }

  create(plan: MaintenancePlan): Observable<any> {
    return this.http.post<any>(
      `${this.apiUrl}`,
      plan,
      { withCredentials: true }
    ).pipe(
      catchError(this.handleError)
    );
  }

getAll(): Observable<ApiListResponse<MaintenancePlanApi>> {
  return this.http.get<ApiListResponse<MaintenancePlanApi>>(
    `${this.apiUrl}`,
    { withCredentials: true }
  ).pipe(
    catchError(this.handleError)
  );
}

  getById(id: number): Observable<{ plan: MaintenancePlan }> {
    return this.http.get<{ plan: MaintenancePlan }>(
      `${this.apiUrl}/${id}`,
      { withCredentials: true }
    ).pipe(
      catchError(this.handleError)
    );
  }

  obtenerPlanPorId(id: number): Observable<any> {
    return this.http.get<any>(
      `${this.apiUrl}/${id}`,
      { withCredentials: true }
    ).pipe(
      catchError(this.handleError)
    );
  }

  update(id: number, plan: MaintenancePlan): Observable<any> {
    return this.http.put<any>(
      `${this.apiUrl}/${id}`,
      plan,
      { withCredentials: true }
    ).pipe(
      catchError(this.handleError)
    );
  }

  cambiarEstado(id: number, activo: boolean): Observable<any> {
    return this.http.patch<any>(
      `${this.apiUrl}/${id}/estado`,
      { activo },
      { withCredentials: true }
    ).pipe(
      catchError(this.handleError)
    );
  }

  createActividad(payload: any): Observable<any> {
    return this.http.post<any>(
      this.actividadesApiUrl,
      payload,
      { withCredentials: true }
    ).pipe(
      catchError(this.handleError)
    );
  }
  
  updateActividad(id: number, payload: any): Observable<any> {
    return this.http.put<any>(
      `${this.actividadesApiUrl}/${id}`,
      payload,
      { withCredentials: true }
    ).pipe(
      catchError(this.handleError)
    );
  }

  createActividades(actividades: any[]): Observable<any[]> {
    return forkJoin(
      actividades.map((actividad) => this.createActividad(actividad))
    ).pipe(
      catchError(this.handleError)
    );
  }

createOrUpdateActividades(
  actividades: any[],
  idsEliminados: number[] = []
): Observable<any[]> {

//  console.log('Actividades a crear/actualizar:', actividades);
//  console.log('IDs a eliminar:', idsEliminados);

  const operaciones = [
    ...actividades.map((actividad) =>
      actividad.id
        ? this.updateActividad(actividad.id, actividad)
        : this.createActividad(actividad)
    ),

    ...idsEliminados.map((id) =>
      this.deleteActividad(id)
    )
  ];

  // Si no hay operaciones
  if (!operaciones.length) {
    return of([]);
  }

  return forkJoin(operaciones).pipe(
    catchError(this.handleError)
  );
}
  getActividadesByPlanId(planId: number): Observable<any[]> {
    return this.http.get<any[]>(
      `${this.actividadesApiUrl}/${planId}`,
      { withCredentials: true }
    ).pipe(
      catchError(this.handleError)
    );
  }

  deleteActividad(id: number): Observable<any> {
    return this.http.delete<any>(
      `${this.actividadesApiUrl}/${id}`,
        { withCredentials: true }
    ).pipe(
      catchError(this.handleError)
    );
  }

  delete(id: number): Observable<any> {
    return this.http.delete<any>(
      `${this.apiUrl}/${id}`,
      { withCredentials: true }
    ).pipe(
      catchError(this.handleError)
    );
  }

  getVehiculosPlan(planId: number): Observable<any[]> {
    return this.http.get<any[]>(
      `${this.apiUrl}/${planId}/vehiculos`,
      { withCredentials: true }
    ).pipe(
      catchError(this.handleError)
    );

  }

getPropuestaProgramacion(
  planId: number
): Observable<PropuestaProgramacionResponse> {
  
    return this.http.get<PropuestaProgramacionResponse>(
      
      `${this.apiUrl}/${planId}/propuesta-programacion`,
      { withCredentials: true }
    ).pipe(
      catchError(this.handleError)
    );
  }

  private handleError(error: any) {
    console.error('Error en PlanMantenimientoService', error);
    return throwError(() => error);
  }

}

export interface MaintenancePlanApi {
  id: number;
  codigo: string;
  nombre: string;
  todosModelos: boolean;
  modeloDesde: number | null;
  modeloHasta: number | null;
  todosCilindrajes: boolean;
  cilindrajeDesde: number | null;
  cilindrajeHasta: number | null;
  descripcion: string | null;
  estado: number; // 1 = activo, 0 = inactivo
  usuarioCreacion: number;
  usuarioModificacion: number | null;
  clase: { idTipos: number; tipos: string };
  marca: { id: number; marca: string };
  combustible: { id: number; nombre: string };
}

export interface ApiListResponse<T> {
  codigo: number;
  ok: boolean;
  data: T[];

}

 export interface PropuestaProgramacionResponse {
  success: boolean;
  planId: number;
  resumen: {
    vehiculos: number;
    actividades: number;
    propuestas: number;
  };
  data: VehiculoPropuesta[];
}

export interface VehiculoPropuesta {
  vehiculoId?: number;
  placa: string;
  kilometrajeActual: number | null;
  actividades: ActividadPropuesta[];
}

export interface ActividadPropuesta {
  actividadId: number;
  sistema: string;
  parte: string;
  tipoMantenimiento: string;

  frecuencia: {
    kilometros: number | null;
    meses: number | null;
  };

  alerta: {
    kilometros: number | null;
    dias: number | null;
  };

  referencia: {
    tipo: 'INICIAL' | 'HISTORIAL';
    kilometraje: number | null;
    fecha: string | null;
  };

  proyeccion: {
    proximoKilometraje: number | null;
    kilometrajeAlerta: number | null;
    proximaFecha: string | null;
    fechaAlerta: string | null;
    estado: 'PROPUESTO' | 'PROGRAMADO' | 'VENCIDO';
  };
}